import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Finance (/finance)
 */
export const financeTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Finance_Tabs_Title"),
    description: t("Tour_Finance_Tabs_Description"),
    target: () => queryTourTarget("finance-tabs"),
    placement: "bottom",
  },
  {
    title: t("Tour_Finance_Month_Title"),
    description: t("Tour_Finance_Month_Description"),
    target: () => queryTourTarget("finance-month-picker"),
    placement: "bottom",
  },
  {
    title: t("Tour_Finance_RentDue_Title"),
    description: t("Tour_Finance_RentDue_Description"),
    target: () => queryTourTarget("finance-rent-due"),
    placement: "top",
  },
  {
    title: t("Tour_Finance_Bulk_Title"),
    description: t("Tour_Finance_Bulk_Description"),
    target: () => queryTourTarget("finance-bulk-request"),
    placement: "left",
  },
];
